// -------------------------------
// 件数表示ロジック
// -------------------------------
function updateVisibleSearchCount() {
  const countElement = document.querySelector('.utility-bar__centre .utility-bar__item');
  if (!countElement) return;

  const products = document.querySelectorAll('.product-block[data-product-id]');
  const visibleProductCount = products.length;

  const originalText = countElement.textContent;
  const regex = /(\d+)\s*件/;
  const match = originalText.match(regex);

  if (match && parseInt(match[1]) !== visibleProductCount) {
    countElement.textContent = originalText.replace(regex, `${visibleProductCount}件`);
  }
}

// -------------------------------
// 最低金額を¥1に強制（表示・送信値・プレースホルダー）
// -------------------------------
function updateMinPriceToOne() {
  const minPriceInput = document.querySelector('input[name="filter.v.price.gte"]');

  if (minPriceInput && (minPriceInput.value === '0' || minPriceInput.value === '' || minPriceInput.value === '¥0')) {
    minPriceInput.value = '1';
  }

  if (minPriceInput && (minPriceInput.placeholder === '0' || minPriceInput.placeholder === '¥0')) {
    minPriceInput.placeholder = '1';
  }

  const currencyInputs = document.querySelectorAll('.cc-price-range__input-container');
  currencyInputs.forEach(container => {
    const span = container.querySelector('.cc-price-range__input-currency-symbol');
    const input = container.querySelector('input');

    if (span && input && (input.placeholder === '0' || input.placeholder === '¥0')) {
      input.placeholder = '1';
    }

    if (span && span.textContent.includes('¥') && input && input.placeholder === '1' && input.value === '0') {
      input.value = '1';
    }
  });
}
